import { __rest } from "tslib";
import { Component, createElement, createRef } from 'rax';
import dayjs from 'dayjs';
import View from '../../view';
import SelectDrawer from '../../select-drawer';
import { ItemContext } from '../../form';
import { Context as LocaleContext } from '../../locale';
import { isFunction, isValidArray } from '../../utils';
import { isBetween, isValidDate, toDate, toValidDate } from '../../utils/date';
import { getFormatType } from '../utils';
class BasePicker extends Component {
    get format() {
        return this.props.format || this.getDefaultFormat();
    }
    constructor(props) {
        super(props);
        this.ref = createRef();
        this.calendarRef = createRef();
        this.handleClear = () => {
            const { onClear, onChange } = this.props;
            if (!('value' in this.props)) {
                this.setState({
                    pickerValue: new Date(),
                    value: null,
                });
            }
            if (onClear) {
                onClear();
            }
            if (onChange) {
                onChange(null);
            }
        };
        const v = toDate(props.value || props.defaultValue);
        let pv = new Date();
        if (isValidDate(v)) {
            pv = v;
        }
        else if (isValidArray(this.props.validRange) &&
            !isBetween(new Date(), this.props.validRange[0], this.props.validRange[1], 'd')) {
            pv = this.props.validRange[0];
        }
        this.state = {
            value: isValidDate(v) ? v : null,
            pickerValue: pv,
            yearPickerVisible: false,
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVisibleChange = this.handleVisibleChange.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.handleYearPickerVisibleChange = this.handleYearPickerVisibleChange.bind(this);
    }
    handleChange(pickerValue) {
        this.setState({ pickerValue });
    }
    handleYearPickerVisibleChange(show) {
        this.setState({ yearPickerVisible: show });
    }
    handleOk() {
        var _a;
        const { onOk, onChange, validRange, disabledDate, format } = this.props;
        const { pickerValue: value, yearPickerVisible } = this.state;
        if (yearPickerVisible && this.calendarRef.current) {
            (_a = this.calendarRef.current) === null || _a === void 0 ? void 0 : _a.toggleYearPicker(false);
            return false;
        }
        if (value) {
            if (Array.isArray(validRange) && !isBetween(value, validRange[0], validRange[1], getFormatType(format, true))) {
                return false;
            }
            if (isFunction(disabledDate) && disabledDate(value, getFormatType(format))) {
                return false;
            }
        }
        if (onChange) {
            onChange(value);
        }
        if (onOk) {
            onOk(value);
        }
        this.setState({ value });
        return true;
    }
    handleVisibleChange(to) {
        const { onVisibleChange } = this.props;
        if (onVisibleChange) {
            onVisibleChange(to);
        }
        const { yearPickerVisible } = this.state;
        if (to && yearPickerVisible) {
            this.setState({ yearPickerVisible: false });
        }
    }
    handleCancel(reason) {
        const { onCancel } = this.props;
        this.setState({
            pickerValue: this.state.value || new Date(),
        });
        if (isFunction(onCancel)) {
            onCancel(reason);
        }
    }
    componentDidUpdate() {
        if ('value' in this.props) {
            const { value, defaultValue } = this.props;
            const newValue = value || defaultValue;
            if (!newValue && this.state.value) {
                this.setState({
                    value: null,
                });
                return;
            }
            if (newValue === this.state.value) {
                return;
            }
            const newValueDate = toDate(newValue);
            if (!isValidDate(newValueDate)) {
                return;
            }
            if (!this.state.value) {
                const newPickerValue = toValidDate(value);
                this.setState({
                    value: newValueDate,
                    pickerValue: newPickerValue,
                });
                return;
            }
            if (newValueDate.getTime() === this.state.value.getTime()) {
                return;
            }
            this.setState({
                value: newValueDate,
                pickerValue: toValidDate(value),
            });
        }
    }
    show() {
        var _a, _b;
        (_b = (_a = this.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.show();
    }
    hide() {
        var _a, _b;
        (_b = (_a = this.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.hide();
    }
    render() {
        const { value, yearPickerVisible } = this.state;
        const _a = this.props, { prefix = 'mt-', iconType, placeholder, align: alignProp, size: sizeProp, disabled, readOnly, hasClear } = _a, others = __rest(_a, ["prefix", "iconType", "placeholder", "align", "size", "disabled", "readOnly", "hasClear"]);
        return (<ItemContext.Consumer>
        {(context) => {
                const { isInsideForm, contentAlign, size: contextSize } = context;
                const align = alignProp || (isInsideForm ? contentAlign : 'left');
                const size = sizeProp || (isInsideForm ? contextSize : 'medium');
                return (<LocaleContext.Consumer>
              {(localeContext) => {
                        var _a, _b;
                        return (<SelectDrawer {...others} ref={this.ref} prefix={prefix} hasClear={hasClear} content={value ? dayjs(value).format(this.format) : ''} align={align} size={size} iconType={iconType} placeholder={placeholder} disabled={disabled} readOnly={readOnly} okText={yearPickerVisible ? ((_b = (_a = localeContext === null || localeContext === void 0 ? void 0 : localeContext.locale) === null || _a === void 0 ? void 0 : _a.DatePicker) === null || _b === void 0 ? void 0 : _b.foldUp) || '收起' : undefined} onOk={this.handleOk} onCancel={this.handleCancel} onClear={this.handleClear} onVisibleChange={this.handleVisibleChange} disableScroll>
                  <View className={`${prefix}datepicker-container`}>{this.renderPicker()}</View>
                </SelectDrawer>);
                    }}
            </LocaleContext.Consumer>);
            }}
      </ItemContext.Consumer>);
    }
}
export default BasePicker;
